// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__14hra","label":"SetPasswdForm_label__HVWig"};